import React from 'react'
import Aboutus from '../../organisms/Aboutussections/Aboutus'

export default function Aboutpage() {
  return (
    <div className='bg-red-500'>
      <Aboutus/>
    </div>
  )
}
